import React, { useState, useEffect } from 'react';
import { Page, SearchBar } from 'components';
import { Results } from './components';
import { useHistory } from 'react-router-dom';
import { Col, Row, Button } from 'react-bootstrap';
import Reload from '../../components/Reload/Reload';
import Header from '../../components/Header/Header';
import Api from 'services/Api';
import { useAppTheme } from '../../contexts/ThemeContext';

const Models3D = () => {
  const history = useHistory();

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.cooperatives?.read !== true) {
    window.location.replace('/home');
  }

  const [buckets, setBuckets] = useState([]);
  const [bucketsToShow, setBucketsToShow] = useState([]);

  const [searchData, setSearchData] = useState('');
  const [loading, setLoading] = useState(true);

  const currentTheme = useAppTheme();

  const handleViewButton = (objectId) => {
    // Encontrar o objeto completo com base no objectId
    const modelData = buckets.find(bucket => bucket.objectId === objectId);

    // Navegar para a página de visualização do modelo 3D passando os dados completos
    history.push({
      pathname: `/models-3d/viewer/${encodeURIComponent(objectId)}`,
      state: {
        modelData: modelData
      }
    });
  };

  useEffect(() => {
    const getBuckets = async () => {
      try {
        const { data } = await Api.get(`/api/v1/buckets-objects?bucketKey=mecanica`);
        const items = data?.items || [];
        setBuckets(items);
        setBucketsToShow(items);
      } catch (error) {
        setBuckets([]);
        alert("Erro ao Carregar!");
      } finally {
        setLoading(false);
      }
    };
    getBuckets()
  }, [])

  const applyFilter = (termRaw) => {
    const term = (termRaw || '').trim();
    if (!term) {
      setBucketsToShow(buckets);
      return;
    }
    const upper = term.toUpperCase();
    const filtered = buckets.filter((item) =>
      ['objectKey', 'bucketKey', 'sha1', 'objectId'].some((key) => {
        const v = item?.[key];
        return v && String(v).toUpperCase().includes(upper);
      })
    );
    setBucketsToShow(filtered);
  };

  const handleSearch = () => {
    applyFilter(searchData);
  };

  const handleSearchData = (e) => {
    const value = e.target.value;
    setSearchData(value);
    applyFilter(value);
  };

  const handleClick = () => {
    history.push('/models-3d/add');
  };

  return (
    <Page className="p-3" title="Objetos 3D">
      <Header page={'Objetos 3D'} />

      {loading && <Reload />}

      <Row className="align-items-center g-2">
        <Col xs={8} sm={6} md={6} lg={6} xl={6} xxl={6}>
          <SearchBar
            onSearch={handleSearch}
            onSearchData={handleSearchData}
            searchData={searchData}
          />
        </Col>
        <Col xs={4} sm={6} md={6} lg={6} xl={6} xxl={6} className="text-md-end text-center">
          <Button
            disabled={!user?.permission?.cooperatives?.write}
            onClick={handleClick}
            variant="success"
          >
            Adicionar Modelo 3D
          </Button>
        </Col>
      </Row>

      {bucketsToShow && (
        <Results
          user={user}
          data={bucketsToShow}
          currentTheme={currentTheme}
          onViewButton={handleViewButton}
        />
      )}

    </Page>
  );
};

export default Models3D;
